import { Outlet, useRouterState } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ActiveSessionBar } from './ActiveSessionBar';
import { BottomNav } from './BottomNav';
import { InstallPrompt } from './InstallPrompt';

/**
 * Mobile-first shell: scrollable content area + sticky bottom nav.
 * Used as the layout for all authenticated routes.
 *
 * Coach-context badging used to live as a separate bottom-pinned banner; it
 * now rides under the PageHeader title (see PageHeader's CoachContextStrip)
 * so the badge sticks to the top of the viewport with the rest of the header
 * and the workout screen reclaims a row of vertical space.
 */
export function AppShell(): React.JSX.Element {
  const { t } = useTranslation();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  // Hide bottom nav while the lifter is mid-set: the workout screen owns the
  // viewport, an accidental tap on "Программы" mid-rep is a real source of
  // lost focus. /workout/new is the chooser (no session yet) so nav stays.
  const inWorkout = pathname.startsWith('/workout/') && pathname !== '/workout/new';
  return (
    <div className="flex min-h-full flex-col">
      <a href="#main" className="skip-link">
        {t('a11y.skipToMain')}
      </a>
      <ActiveSessionBar />
      <main id="main" className="flex-1 overflow-y-auto pb-2">
        <Outlet />
      </main>
      <InstallPrompt />
      {inWorkout ? null : <BottomNav />}
    </div>
  );
}
